import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import "@qota/ui/styles.css";
import "./styles/app.css";
import { router } from "./router";
import { loadChatwoot } from "./lib/chatwoot";

/**
 * Cache delle richieste.
 *
 * `retry: 1` e non il default di 3: su un 404 o un 403 riprovare non serve, e
 * su una rete assente allunga solo l'attesa prima di dire all'utente cosa è
 * successo.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: true,
    },
  },
});

const container = document.getElementById("root");
if (!container) throw new Error("Elemento #root non trovato in index.html");

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);

loadChatwoot();
